import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReportDom from "../../../components/common/ReportDom";
import QuotationVoucherBody from "./QuotationVoucherBody";
import QuotationVoucherBodyDesignA from "./QuotationVoucherBodyDesignA";
import { fetchSingleInstitutionDetails } from "../../../store/commonThunks/lookups";

export default function PrintQuotationVoucher() {
  const { id } = useParams();
  const [ready, setReady] = useState(false);
  const dispatch = useDispatch();
  const { institutionData } = useSelector((state) => state.lookups);
  const isDesignA = institutionData?.print_template === "design_a";

  // Standalone print route (a fresh tab/page load) --
  // institutionData.print_template can't be assumed already loaded.
  useEffect(() => {
    dispatch(fetchSingleInstitutionDetails()).finally(() => setReady(true));
  }, [dispatch]);

  if (!id || !ready) return null;

  return (
    <div
      className="puppeteer-print-page"
      style={{
        background: "#fff",
        padding: 0,
      }}
    >
      {isDesignA ? (
        <ReportDom mode="no-title" renderTable={() => <QuotationVoucherBodyDesignA id={id} />} />
      ) : (
        <ReportDom
          renderTable={() => (
            <QuotationVoucherBody
              id={id}
              printMode
            />
          )}
        />
      )}
    </div>
  );
}